
import {HOME_TYPE} from "./Types"

export const initialHomeState = {
    loading: false,
    brandName:"ProjectKart",
    contactName:"",
    contactEmail:"",
    contactPhone:"",
    contactMessage:"",
}

export function homeReducer(state,action){
    switch(action.type){
        case HOME_TYPE.BRAND_NAME:
            return {...state,brandName:action.payload}
        case HOME_TYPE.CONTACT_NAME:
            return {...state,contactName:action.payload}
        case HOME_TYPE.CONTACT_EMAIL:
            return {...state,contactEmail:action.payload}
        case HOME_TYPE.CONTACT_PHONE:
            return {...state,contactPhone:action.payload}
        case HOME_TYPE.CONTACT_MESSAGE:
            return {...state,contactMessage:action.payload}
        default:
            return state
    }
}